<template>
  <div>
    <v-list-item inactive
                 :disabled="!device.currentlyEnabled"
                 :ripple="false"
                 class="px-0 mb-4">
      <v-list-item-icon class="ml-0 mr-3">
        <v-icon :color="device.currentlyEnabled === false ? '' : 'primary'">business</v-icon>
      </v-list-item-icon>
      <v-list-item-content>
        <v-list-item-title :class="device.currentlyEnabled === false ? '' : 'primary--text'" class="font-weight-bold font-size-03" v-text="device.name"></v-list-item-title>
        <v-list-item-subtitle class="font-size-02">{{ device.currentlyEnabled === false ? $t('app.additional-permission.no-permission') : deviceStatus }}</v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>

    <v-btn depressed block large
           class="font-weight-bold"
           color="primary"
           :disabled="lockState === SimulatedStates.REQUESTING || device.currentlyEnabled === false"
           @click="executeNukiBoxOperation(device.boxId)"
           v-html="$t('accesses-card.execute-button')"/>
  </div>
</template>

<script>

export const SimulatedStates = Object.freeze({
  IDLE: "idle",
  REQUESTING: "requesting",
  UNLATCHING: "unlatching",
  ACTUATED: "actuated"
})

export default {
  name: "NukiBox",

  props: {
    device: Object
  },

  data() {
    return {
      simulatedStatusDuration: 5000,
      SimulatedStates: SimulatedStates,
      lockState: null
    }
  },

  computed: {
    deviceStatus() {
      switch (this.lockState) {
        case SimulatedStates.REQUESTING:
          return this.$t("accesses-card.device-status.actuate")
        case SimulatedStates.ACTUATED:
          return this.$t("accesses-card.device-status.actuated")
        default:
          return this.$t("accesses-card.device-status.reachable")
      }
    }
  },

  methods: {
    executeNukiBoxOperation: function (boxId) {
      this.lockState = SimulatedStates.REQUESTING;
      this.$rhRequest.sendPost({
        endpoint: "nuki-service/nuki-box-unlock",
        data: {
          boxId: boxId
        }
      }, (response) => {
        if (response?.data?.code !== 0 || response?.data?.data?.success === false) {
          this.$root.bisatoast.error({message: this.$t('accesses-card.nuki-operation.failed')})
          this.lockState = SimulatedStates.IDLE
        } else {
          this.lockState = SimulatedStates.ACTUATED
          setInterval(() => {
            this.lockState = SimulatedStates.IDLE
          }, this.simulatedStatusDuration)
        }
      }, (err) => {
        console.error(err)
        this.$root.bisatoast.error({message: this.$t('accesses-card.nuki-operation.failed')})
        this.lockState = SimulatedStates.IDLE
      })
    }
  }
}
</script>
